import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import * as XLSX from 'xlsx';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import Swal from 'sweetalert2';
import { Router, RouterModule } from '@angular/router';
import { ApiService } from '../../../api.service';
import { AgGridAngular } from 'ag-grid-angular';
import { ExcelService } from 'src/app/excel.service';
type AOA = any[][];




@Component({
  selector: 'app-uploadexcefint',
  templateUrl: './uploadexcefint.component.html',
  styleUrls: ['./uploadexcefint.component.css']
})
export class UploadexcefintComponent implements OnInit {
  @ViewChild('fileControl') fileControl: ElementRef;
  timeLeft: number = 0;
  interval;
  data: AOA = [];
  wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  fileName: string = 'SheetJS.xlsx';
  file: any;
  arrayBuffer: any;
  Last_existing_count = 0;

  excel_data = [];
  loader_status = false;

  removeChars(str: string): string {
    return str ? str.replace(/"| /g, '') : '';
  }
  constructor(
    private _api: ApiService,
    private excelService: ExcelService,
    @Inject(SESSION_STORAGE) private storage: StorageService
  ) { }

  ngOnInit(): void {
  }





  onFileChange(event: any) {
    this.excel_data = [];
    this.file = event.target.files[0];

    let fileReader = new FileReader();
    fileReader.onload = (e) => {
      try {
        let arrayBuffer = fileReader.result;
        if (arrayBuffer instanceof ArrayBuffer) {
          let data = new Uint8Array(arrayBuffer);

          let arr = new Array<string>();

          for (let i = 0; i < data.length; ++i) {
            arr[i] = String.fromCharCode(data[i]);
          }

          let bstr = arr.join("");
          let workbook = XLSX.read(bstr, { type: "binary" });
          let first_sheet_name = workbook.SheetNames[0];
          let worksheet = workbook.Sheets[first_sheet_name];

          let arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });

          const excelDataArray: any = arraylist.map((excelData: any) => {
            const cleanedData: any = {} as any;
            for (const key in excelData as Record<string, unknown>) {
              if (Object.prototype.hasOwnProperty.call(excelData, key)) {
                cleanedData[key] = typeof excelData[key] === 'string'
                  ? this.removeChars(excelData[key].trim())
                  : excelData[key];
              }
            }
            return cleanedData;
          });

          this.excel_data = excelDataArray;
          console.log(arraylist);
        } else {
          console.error('The file content is not in the expected format (ArrayBuffer).');
          // Handle the error or notify the user
        }
      } catch (error) {
        console.error('Error reading or parsing the file:', error);
        // Handle the error appropriately, e.g., show a message to the user
      }
    };

    fileReader.readAsArrayBuffer(this.file);
  }








  closeExcel() {
    this.fileControl.nativeElement.value = null;
  }


  // checknow(){
  //   this.loader_status = true;
  //   this.Last_existing_count = 0;
  //   this.timeLeft = this.excel_data.length - 1;
  //   this.interval = setInterval(() => {
  //     if(this.timeLeft > -1) {
  //       let a = {
  //         excel_data : this.excel_data[this.timeLeft]
  //       }
  //       let temp_no = this.timeLeft;
  //       this._api.check_excel_data(a).subscribe(
  //         (response: any) => {
  //           console.log(response.Data);
  //           console.log(response.Message);
  //             this.excel_data[temp_no].fint_id = response.Data;
  //             this.excel_data[temp_no].allocation_check = response.allocation_check;
  //             this.excel_data[temp_no].user_id = response.user_id || "";
  //             this.timeLeft--;
  //         }
  //       );
  //     } else {
  //       this.timeLeft = -1;
  //       this.loader_status = false;
  //     }
  //   },2000);
  // }

  check_data(){
    this.loader_status = true;
    this.Last_existing_count = 0;
    this.timeLeft = 0;
    this.timeLeft = this.excel_data.length - 1;
    this.checknow1();
  }


  checknow(){
    console.log(this.timeLeft);
      if(this.timeLeft > -1) {
        this.excel_data[this.timeLeft].email = ""+this.excel_data[this.timeLeft].email.toLowerCase();
        console.log(this.excel_data[this.timeLeft].email);
        let a = {
          excel_data : this.excel_data[this.timeLeft]
        }
        let temp_no = this.timeLeft;
        this._api.check_excel_data2(a).subscribe(
          (response: any) => {
            console.log(response);
            console.log(response.Message);
              this.excel_data[temp_no].fint_id = response.Data;
              this.excel_data[temp_no].user_id = response.user_id;
              this.excel_data[temp_no].allocation_check = response.allocation_check;
              this.timeLeft--;
              this.checknow();
          }
        );
      } else {
        this.timeLeft = -1;
        this.loader_status = false;
      }
  }

  // checknow1(){
  //   this.loader_status = true;
  //   this.Last_existing_count = 0;
  //   this.timeLeft = this.excel_data.length - 1;
  //   this.interval = setInterval(() => {
  //     if(this.timeLeft > -1) {
  //       if(this.excel_data[this.timeLeft].finterstal_id == ''){
  //       this.excel_data[this.timeLeft].email = ""+this.excel_data[this.timeLeft].email.toLowerCase();
  //       console.log(this.excel_data[this.timeLeft].email);
  //       let a = {
  //         excel_data : this.excel_data[this.timeLeft]
  //       }
  //       let temp_no = this.timeLeft;
  //       this._api.check_excel_data2(a).subscribe(
  //         (response: any) => {
  //           console.log(response);
  //           console.log(response.Message);
  //             this.excel_data[temp_no].fint_id = response.Data;
  //             this.excel_data[temp_no].user_id = response.user_id;
  //             this.excel_data[temp_no].allocation_check = response.allocation_check;
  //             this.timeLeft--;
  //         }
  //       );
  //     }
  //     else{
  //       this.timeLeft--;
  //     }
  //     } else {
  //       this.timeLeft = -1;
  //       this.loader_status = false;
  //       clearInterval(this.interval);
  //     }
  //   },1000);
  // }
  checknow1() {
    this.loader_status = true;

    this.loader_status = true;
    const excelData = this.excel_data;

    this._api.check_excel_data2(excelData).subscribe(
      (response: any) => {
        console.log(response);
        const apiData: any = response['Data'];

        excelData.forEach(item => {
          const matchedElement = apiData.find(element =>
            element.passport_no === item.passport_no &&
            element.acc_no === item.acc_no &&
            element.email === item.email
          );

          if (matchedElement) {
            item.fint_id = matchedElement.fint_id;
            item.user_id = matchedElement.user_id;
            item.allocation_check = matchedElement.allocation_check;
            item.fint_id = matchedElement.finterstal_id;
            item.email = matchedElement.email.trim().toLowerCase()

          }

        });

        alert(response.Message);
        this.loader_status = false;
      }
    );

    this.timeLeft--;
  }


  export(): void {
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.excel_data);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }


  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.excel_data,'Fint_Gen');
  }

}
